import { render, staticRenderFns } from "./organization-kvkk-roadmap-view.vue?vue&type=template&id=4be4def8&scoped=true"
import script from "./organization-kvkk-roadmap-view.vue?vue&type=script&lang=js"
export * from "./organization-kvkk-roadmap-view.vue?vue&type=script&lang=js"
import style0 from "./organization-kvkk-roadmap-view.vue?vue&type=style&index=0&id=4be4def8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be4def8",
  null
  
)

export default component.exports